import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/axios';
import '../styles/VerifyResetTokenPage.css';
import logo from '../assets/elon_logo.png';

function VerifyResetTokenPage() {
  const [tokenIngresado, setTokenIngresado] = useState('');
  const [error, setError] = useState('');
  const [info, setInfo] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleVerify = async (e) => {
    e.preventDefault();
    setError('');
    setInfo('');
    setIsLoading(true);

    try {
      await api.get(`/auth/reset-password/verify/${tokenIngresado}`);
      localStorage.setItem('resetToken', tokenIngresado);
      setInfo('Token válido. Redirigiendo a la página de cambio de contraseña...');
      
      setTimeout(() => {
        navigate('/change-password');
      }, 2000);
    } catch (err) {
      console.error(err);
      setError('Token inválido o expirado');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="verify-token-bg">
      <div className="verify-token-card">
        <img 
          src={logo} 
          alt="Elon School Logo" 
          className="verify-token-logo"
          loading="lazy"
        />
        
        <h1 className="verify-token-title">Verificar Token</h1>
        
        {error && (
          <div className="verify-token-error-message" role="alert">
            {error}
          </div>
        )}
        
        {info && (
          <div className="verify-token-success-message" role="status">
            {info}
          </div>
        )}

        <form onSubmit={handleVerify} noValidate>
          <div className="verify-token-form-group">
            <label htmlFor="token">Ingresa el token que recibiste por correo:</label>
            <input
              id="token"
              type="text"
              value={tokenIngresado}
              onChange={(e) => setTokenIngresado(e.target.value)}
              placeholder="Ingresa el token aquí"
              required
              autoComplete="off"
              aria-describedby={error ? "error-message" : undefined}
            />
          </div>

          <div className="verify-token-button-group">
            <button 
              type="button" 
              className="verify-token-btn-back" 
              onClick={() => navigate('/login')}
              disabled={isLoading}
            >
              Regresar
            </button>
            <button 
              type="submit" 
              className="verify-token-btn-submit"
              disabled={isLoading}
            >
              {isLoading ? 'Verificando...' : 'Verificar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default VerifyResetTokenPage;
